var map = {
	"./anas-no-bg.png": "4568",
	"./asdep-no-bg.png": "b35c",
	"./bancaubi-logo-no-bg.png": "e0c6",
	"./bancaubi-logo.jpg": "064d",
	"./banco-desio-no-bg.png": "1c75",
	"./bancobpm-logo-no-bg.png": "7123",
	"./caspop-no-bg.png": "c6b2",
	"./cassaprevint-logo.png": "ff8c",
	"./cnr-no-bg.png": "3875",
	"./consob-no-bg.png": "11f0",
	"./corte-costituzionale-no-bg.png": "ce27",
	"./fas-logo.png": "500b",
	"./fasif-logo-no-bg.png": "fae9",
	"./fasif-logo.png": "5eeb",
	"./fisdaf-logo-no-bg.png": "5fa4",
	"./fisdaf-logo.jpg": "1a86",
	"./fsilogo-no-bg.png": "9501",
	"./fsilogo.png": "cb43",
	"./intesarbm-logo-no-bg.png": "313f",
	"./intesarbm-logo.png": "ca16",
	"./isp-protezione-nobg.png": "0781",
	"./isp-protezione.jpg": "91ab",
	"./metasalute-logo-no-bg.png": "e307",
	"./metasalute-logo.jpg": "d64b",
	"./mutua-ulisse-no-bg.png": "ee7f",
	"./pmed-logo-no-bg.png": "49e7",
	"./pmed-logo.jpg": "0d76",
	"./pmi-salute-no-bg.png": "52f0",
	"./poste-bg.jpg": "5875",
	"./presidenza-della-repubblica-no-bg.png": "3690",
	"./rb-care-logo-no-bg.png": "1773",
	"./rbsistemawelfare-logo.png": "10c8",
	"./rbtech-logo.jpg": "3735",
	"./sport-e-salute-no-bg.png": "6a12d",
	"./umanawelfare-logo-no-bg.png": "38cc",
	"./umanawelfare-logo.jpg": "bbfc",
	"./unica-logo-no-bg.png": "1a3f",
	"./unica-logo.png": "68749"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";